import {Tabs as MuiTabs, TabsProps as MuiTabsProps} from "@mui/material";

export default function Tabs(props: MuiTabsProps) {
    return (
        <MuiTabs {...props}>
            {props.children}
        </MuiTabs>
    );
}